import { render, staticRenderFns } from "./opened-box.vue?vue&type=template&id=43f13c02"
import script from "./opened-box.vue?vue&type=script&lang=js"
export * from "./opened-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports